import { Component, Input, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { AuthService } from 'src/app/auth/auth.service';
import { Person } from 'src/app/people/models/person';
import { Seat } from '../../models/team/seat';
import { SeatStatus } from '../../models/team/seatStatus';
import { Team } from '../../models/team/team';
import { TeamService } from '../../services/team.service';

@Component({
  selector: 'seat-status-override',
  templateUrl: './seat-status-override.component.html',
  styleUrls: ['./seat-status-override.component.scss'],
})
export class SeatStatusOverrideComponent implements OnInit {
  @Input()
  seat: Seat;

  public team: Team = null;
  public person: Person = null;
  public status: string = null;

  constructor(private authService: AuthService, private teamService: TeamService) {}

  ngOnInit() {
    this.status = this.getSeatStatusText();
    this.person = this.seat?.person;
    this.team = this.teamService.currentTeam;
  }

  getSeatStatusText(): string {
    if (this.seat?.statusDescription == 'NoShow') return 'No Show';
    if (this.seat?.statusDescription == 'NoResponse') return 'No Response';
    return this.seat?.statusDescription;
  }

  getSeatStatusColor(): string {
    return this.seat?.statusDescription;
  }

  isAccepted() {
    return this.seat?.status === SeatStatus.Accepted;
  }

  isDeclined() {
    return this.seat?.status === SeatStatus.Declined;
  }

  isNoShow() {
    return this.seat?.status === SeatStatus.NoShow;
  }

  isPicked() {
    return this.seat?.status === SeatStatus.Picked;
  }

  isInvited() {
    return this.seat?.status === SeatStatus.Invited;
  }

  isNoResponse() {
    return this.seat?.status === SeatStatus.NoResponse;
  }

  isBench() {
    return this.seat?.status === SeatStatus.Bench;
  }

  overridePicked() {
    this.overrideState(SeatStatus.Picked);
  }

  overrideInvited() {
    this.overrideState(SeatStatus.Invited);
  }

  overrideNoResponse() {
    this.overrideState(SeatStatus.NoResponse);
  }

  overrideAccepted() {
    this.overrideState(SeatStatus.Accepted);
  }

  overrideDeclined() {
    this.overrideState(SeatStatus.Declined);
  }

  overrideNoShow() {
    this.overrideState(SeatStatus.NoShow);
  }

  canEditPersonOnTeam() {
    return this.isManager() && this.person && !this.person.isArchived();
  }

  isManager() {
    return this.authService.managerLevelAccess && this.person;
  }

  private overrideState(seatStatus: SeatStatus) {
    this.teamService.overrideSeatStatus(this.team.id, this.seat, seatStatus);
  }
}
